import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  previousRecordsHeader: {
    id: 'vehicleSearchModal.previousRecordsHeader',
    defaultMessage: 'Aiemmat työt',
  },
  noPreviousRecordsFound: {
    id: 'vehicleSearchModal.noPreviousRecordsFound',
    defaultMessage: 'Aiempia töitä ei löytynyt',
  },
  technicalDetailsHeader: {
    id: 'vehicleSearchModal.technicalDetailsHeader',
    defaultMessage: 'Tekniset tiedot',
  },
  registrationNumber: {
    id: 'vehicleSearchModal.registrationNumber',
    defaultMessage: 'Rekisteritunnus',
  },
  vehicleClass: {
    id: 'vehicleSearchModal.vehicleClass',
    defaultMessage: 'Ajoneuvoluokka',
  },
  makeAndModel: {
    id: 'vehicleSearchModal.makeAndModel',
    defaultMessage: 'Merkki ja malli',
  },
  modelYear: {
    id: 'vehicleSearchModal.modelYear',
    defaultMessage: 'Vuosimalli',
  },
  serialNumber: {
    id: 'vehicleSearchModal.serialNumber',
    defaultMessage: 'Valmistenumero',
  },
  vehicleStatus: {
    id: 'vehicleSearchModal.vehicleStatus',
    defaultMessage: 'Ajoneuvon tila',
  },
  color: {
    id: 'vehicleSearchModal.color',
    defaultMessage: 'Väri',
  },
  fuel: {
    id: 'vehicleSearchModal.fuel',
    defaultMessage: 'Käyttövoima',
  },
  driveTrain: {
    id: 'vehicleSearchModal.driveTrain',
    defaultMessage: 'Voimansiirto',
  },
  transmission: {
    id: 'vehicleSearchModal.transmission',
    defaultMessage: 'Vaihteisto',
  },
  displacement: {
    id: 'vehicleSearchModal.displacement',
    defaultMessage: 'Iskutilavuus',
  },
  maxNetEffect: {
    id: 'vehicleSearchModal.maxNetEffect',
    defaultMessage: 'Suurin nettoteho',
  },
  weight: {
    id: 'vehicleSearchModal.weight',
    defaultMessage: 'Omamassa',
  },
  maxNetWeight: {
    id: 'vehicleSearchModal.maxNetWeight',
    defaultMessage: 'Tieliikenteessä suurin sallittu kokonaismassa',
  },
  maxTechNetWeight: {
    id: 'vehicleSearchModal.maxTechNetWeight',
    defaultMessage: 'Tekninen suurin sallittu kokonaismassa',
  },
  length: {
    id: 'vehicleSearchModal.length',
    defaultMessage: 'Pituus',
  },
  width: {
    id: 'vehicleSearchModal.width',
    defaultMessage: 'Leveys',
  },
  height: {
    id: 'vehicleSearchModal.height',
    defaultMessage: 'Korkeus',
  },
  notKnown: {
    id: 'vehicleSearchModal.notKnown',
    defaultMessage: 'Ei tiedossa',
  },
  registerAndInspectionHeader: {
    id: 'vehicleSearchModal.registerAndInspectionHeader',
    defaultMessage: 'Rekisteri ja katsastustiedot',
  },
  initializationDate: {
    id: 'vehicleSearchModal.initializationDate',
    defaultMessage: 'Käyttöönottopvm',
  },
  lastInspection: {
    id: 'vehicleSearchModal.lastInspection',
    defaultMessage: 'Edellinen katsastus, päätös ja pvm',
  },
  nextInspectionDate: {
    id: 'vehicleSearchModal.nextInspectionDate',
    defaultMessage: 'Seuraava katsastus',
  },
  firstRegistrationDate: {
    id: 'vehicleSearchModal.firstRegistrationDate',
    defaultMessage: 'Ensirekisteröintipvm',
  },
  insuranceInfoHeader: {
    id: 'vehicleSearchModal.insuranceInfoHeader',
    defaultMessage: 'Vakuutustiedot (Liikennevakuutus)',
  },
  insuranceCompany: {
    id: 'vehicleSearchModal.insuranceCompany',
    defaultMessage: 'Vakuutusyhtiö',
  },
  insuranceStartAndEndDate: {
    id: 'vehicleSearchModal.insuranceStartAndEndDate',
    defaultMessage: 'Vakuutuksen alku- ja loppupvm',
  },
  insuredParty: {
    id: 'vehicleSearchModal.insuredParty',
    defaultMessage: 'Vakuutuksenottaja',
  },
  transferPermitHeader: {
    id: 'vehicleSearchModal.transferPermitHeader',
    defaultMessage: 'Ajoneuvolla on siirtolupa',
  },
  purposeOfUse: {
    id: 'vehicleSearchModal.purposeOfUse',
    defaultMessage: 'Tarkoitus',
  },
  validityPeriod: {
    id: 'vehicleSearchModal.validityPeriod',
    defaultMessage: 'Voimassaoloaika',
  },
  applicant: {
    id: 'vehicleSearchModal.applicant',
    defaultMessage: 'Hakija',
  },
  route: {
    id: 'vehicleSearchModal.route',
    defaultMessage: 'Reitti',
  },
  restrictionsHeader: {
    id: 'vehicleSearchModal.restrictionsHeader',
    defaultMessage: 'Ajoneuvolla rajoitustietoja',
  },
  restrictionType: {
    id: 'vehicleSearchModal.restrictionType',
    defaultMessage: 'Rajoituksen tyyppi',
  },
  restrictionSeverity: {
    id: 'vehicleSearchModal.restrictionSeverity',
    defaultMessage: 'Vakavuus 1-5',
  },
  remarksHeader: {
    id: 'vehicleSearchModal.remarksHeader',
    defaultMessage: 'Ajoneuvolla seuraavat rajoitustiedot',
  },
  remarks: {
    id: 'vehicleSearchModal.remarks',
    defaultMessage: 'Rajoitukset',
  },
  notAvailable: {
    id: 'vehicleSearchModal.notAvailable',
    defaultMessage: 'Ei saatavilla',
  },
  applicantName: {
    id: 'vehicleSearchModal.applicantName',
    defaultMessage: 'Nimi',
  },
  businessId: {
    id: 'vehicleSearchModal.businessId',
    defaultMessage: 'Y-tunnus',
  },
  address: {
    id: 'vehicleSearchModal.address',
    defaultMessage: 'Osoite',
  },
  ownershipStartAndEndDate: {
    id: 'vehicleSearchModal.ownershipStartAndEndDate',
    defaultMessage: 'Omistussuhteen alku- ja loppupvm',
  },
  searchError: {
    id: 'vehicleSearchModal.searchError',
    defaultMessage: 'Haussa tapahtui virhe',
  },
  searchErrorTitle: {
    id: 'vehicleSearchModal.searchErrorTitle',
    defaultMessage: 'Virhe',
  },
  note: {
    id: 'vehicleSearchModal.note',
    defaultMessage: 'Huom!',
  },
  fetchFromTraficom: {
    id: 'vehicleSearchModal.fetchFromTraficom',
    defaultMessage: 'Hae Traficomista',
  },
})
